import { render, staticRenderFns } from "./model_51.vue?vue&type=template&id=012e4435&scoped=true"
import script from "./model_51.vue?vue&type=script&lang=js"
export * from "./model_51.vue?vue&type=script&lang=js"
import style0 from "./model_51.vue?vue&type=style&index=0&id=012e4435&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012e4435",
  null
  
)

export default component.exports